/** Sound tuning; asset imports stay with the browser bundler. Times are seconds. */
export const audioConfig = {
  sounds: {
    rifle: { volume: 0.48, interval: 0.065, limit: 5 },
    machineGun: { volume: 0.5, interval: 0.09, limit: 4 },
    cannon: { volume: 0.8, interval: 0.12, limit: 4 },
    launcher: { volume: 0.55, interval: 0.12, limit: 3 },
    grenade: { volume: 0.65, interval: 0.12, limit: 3 },
    beam: { volume: 0.65, interval: 0.12, limit: 3 },
    hit: { volume: 0.2, interval: 0.08, limit: 3 },
    small: { volume: 0.55, interval: 0.12, limit: 3 },
    medium: { volume: 0.75, interval: 0.15, limit: 3 },
    large: { volume: 0.85, interval: 0.25, limit: 2 },
    collapse: { volume: 0.8, interval: 0.3, limit: 2 },
    select: { volume: 0.6, interval: 0.08, limit: 1 },
    order: { volume: 0.65, interval: 0.12, limit: 1 },
    error: { volume: 0.75, interval: 0.3, limit: 1 },
    insufficientMoney: { volume: 0.75, interval: 0.3, limit: 1 },
    ready: { volume: 0.7, interval: 1.5, limit: 1, voice: true },
    constructionStarted: { volume: 0.65, interval: 0.2, limit: 1 },
    complete: { volume: 0.7, interval: 0.3, limit: 2 },
    constructionComplete: { volume: 0.7, interval: 0.3, limit: 1 },
    buildingSold: { volume: 0.7, interval: 0.3, limit: 1 },
    lowPower: { volume: 0.7, interval: 4, limit: 1 },
    placement: { volume: 0.7, interval: 0.1, limit: 1 },
    uiClick: { volume: 0.5, interval: 0.05, limit: 3 },
    alert: { volume: 0.85, interval: 10, limit: 1 },
    win: { volume: 0.85, interval: 3, limit: 1 },
    lose: { volume: 0.85, interval: 3, limit: 1 },
    menu: { volume: 0.65, interval: 0, limit: 2 },
    calm: { volume: 0.65, interval: 0, limit: 2 },
    battle: { volume: 0.65, interval: 0, limit: 2 },
    wind: { volume: 0.22, interval: 0, limit: 2 },
    shot: { volume: 0, interval: 0, limit: 0 },
    death: { volume: 0, interval: 0, limit: 0 },
    fired: { volume: 0, interval: 0, limit: 0 },
    destroyed: { volume: 0, interval: 0, limit: 0 },
  },
  voices: {
    "voice-announce-attack": { volume: 0.75, interval: 6, announce: true },
    "voice-announce-unit-attack": { volume: 0.72, interval: 8, announce: true },
    "voice-announce-unit-lost": { volume: 0.78, interval: 4, announce: true },
    "voice-announce-enemy": { volume: 0.75, interval: 6, announce: true },
    "voice-announce-enemy-base": { volume: 0.75, interval: 8, announce: true },
    "voice-announce-low-power": { volume: 0.75, interval: 10, announce: true },
    "voice-announce-started": { volume: 0.72, interval: 4, announce: true },
    "voice-announce-complete": { volume: 0.75, interval: 3, announce: true },
    "voice-announce-ready": {
      volume: 0.72,
      interval: 3,
      announce: true,
    },
    "voice-announce-cancelled": { volume: 0.72, interval: 3, announce: true },
    "voice-announce-victory": { volume: 0.8, interval: 3, announce: true },
    "voice-announce-defeat": { volume: 0.8, interval: 3, announce: true },
    "voice-announce-error": { volume: 0.72, interval: 2, announce: true },
    "voice-announce-active": { volume: 0.75, interval: 3, announce: true },
    "voice-group-select": { volume: 0.7, interval: 1.5 },
    "voice-enemy-engage": { volume: 0.7, interval: 25, announce: true },
  },
};

export const audioPlaybackConfig = {
  voiceVolume: 0.7,
  voiceInterval: 0.12,
  voiceLimit: 1,
  retrySeconds: 30,
  masterGain: 0.7,
  compressor: { threshold: -12, knee: 12, ratio: 12, attack: 0.003, release: 0.2 },
  positionedVoicesMax: 20,
  voicesMax: 24,
  audibleRadiusMin: 240,
  audibleRadiusScale: 1.65,
  panMax: 0.9,
  pitchBase: 0.97,
  pitchVariation: 0.06,
  volumeBase: 0.94,
  volumeVariation: 0.12,
  duckTailSeconds: 0.4,
  voiceCooldownSeconds: 0.5,
  musicFadeSeconds: 1.3,
  musicStopSeconds: 6,
  windOverlapSeconds: 1,
  musicOverlapSeconds: 2,
  pausedEffectsGain: 0.12,
  pausedMusicGain: 0.15,
  duckedMusicGain: 0.55,
  effectsEaseSeconds: 0.08,
  musicEaseSeconds: 0.2,
  combatWindowSeconds: 5,
  battleShotThreshold: 6,
  battleHoldSeconds: 12,
  missileWarning: { interval: 0, limit: 24 },
};
